import { ACTION_BLUE, BLACK, PRIMARY_COLOR } from '../../theme/colorConstants';
import { PRIMARY_FONT } from '../../theme/fontConstants';

const modalStyles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalBox: {
    position: 'relative',
    maxWidth: '900px',
    bgcolor: 'background.paper',
    borderRadius: 4,
    boxShadow: 24,
    p: 3,
    maxHeight: '90vh',
    overflow: 'hidden',
  },
  contentBox: {
    maxHeight: 'calc(90vh - 32px)',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  title: {
    fontSize: '24px',
    textAlign: 'left',
    color: BLACK[100],
    fontFamily: PRIMARY_FONT[700],
  },
  subtitle: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    textAlign: 'left',
    color: BLACK[70],
  },
  optionsContainer: {
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    gap: 3,
  },
  optionCard: {
    flex: 1,
    border: `2px solid ${BLACK[30]}`,
    borderRadius: 4,
    p: 3,
    pb: 4, // Reduced bottom padding
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    position: 'relative',
    minHeight: '180px', // Reduced minimum height
    display: 'flex',
    flexDirection: 'column',
    '&:hover': {
      borderColor: PRIMARY_COLOR[70],
      boxShadow: `0 4px 12px ${PRIMARY_COLOR[20]}`,
    },
  },
  selectedOptionCard: {
    borderColor: PRIMARY_COLOR[70],
    backgroundColor: PRIMARY_COLOR[30],
    boxShadow: `0 4px 12px ${PRIMARY_COLOR[20]}`,
  },
  optionTitle: {
    fontSize: '20px',
    fontFamily: PRIMARY_FONT[700],
    color: PRIMARY_COLOR[70],
    mb: 1.5,
  },
  optionDescription: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    color: BLACK[70],
    mb: 1.5,
  },
  // Example section - design specs from marked areas
  exampleContainer: {
    mb: 1.5,
  },
  examplePill: {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[700],
    color: BLACK[10],
    textTransform: 'capitalize',
    backgroundColor: PRIMARY_COLOR[70],
    width: 'fit-content',
    height: '30px',
    padding: '5px 10px',
    borderRadius: '4px',
    mb: 1,
  },
  exampleLines: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5,
  },
  exampleLine: {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[300],
    color: BLACK[100],
    fontStyle: 'normal',
  },
  exampleBold: {
    fontFamily: PRIMARY_FONT[700],
    fontStyle: 'normal',
    color: BLACK[100],
  },
  exampleItalic: {
    fontFamily: PRIMARY_FONT[300],
    fontStyle: 'italic',
    color: BLACK[100],
  },
  exampleWeekLabel: {
    fontFamily: PRIMARY_FONT[700],
    fontStyle: 'normal',
    color: BLACK[100],
  },
  exampleRepeatRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1,
    mt: 0.5,
  },
  exampleRepeatDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: ACTION_BLUE.ACTION_BLUE,
    flexShrink: 0,
    mt: 0.75,
  },
  exampleRepeatText: {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[300],
    color: PRIMARY_COLOR[70],
    fontStyle: 'normal',
  },
  selectionIndicator: {
    display: 'flex',
    height: '24px',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 1,
    flexShrink: 0,
    mt: 1,
  },
  optionBestForContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 0.5,
    flexShrink: 0,
    flex: 1,
  },
  optionBestFor: {
    fontSize: '14px',
    fontFamily: PRIMARY_FONT[700],
    color: BLACK[100],
    whiteSpace: 'nowrap',
  },
  optionBestForText: {
    fontSize: '16px',
    fontFamily: PRIMARY_FONT[300],
    color: BLACK[70],
    flex: 1,
  },
  radioButton: {
    width: 20,
    height: 20,
    border: `2px solid ${PRIMARY_COLOR[70]}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  selectedRadioButton: {
    backgroundColor: PRIMARY_COLOR[70],
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'white',
  },
  selectedText: {
    fontSize: '16px',
    color: PRIMARY_COLOR[70],
    fontFamily: PRIMARY_FONT[700],
    fontStyle: 'italic',
    whiteSpace: 'nowrap',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: 2,
    mb: 2,
  },
  cancelButton: {
    border: `1px solid ${PRIMARY_COLOR[70]}`,
    color: PRIMARY_COLOR[70],
    width: '100px',
    backgroundColor: 'white',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[10],
    },
  },
  nextButton: {
    backgroundColor: PRIMARY_COLOR[70],
    color: 'white',
    width: '100px',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: PRIMARY_COLOR[80],
    },
    '&:disabled': {
      backgroundColor: BLACK[30],
      color: BLACK[60],
    },
  },
};

export default modalStyles;
